export default {
  fields: {
    createdAt: 'Creado',
    status: 'Estado',
    enabled: 'Habilitado',
    disabled: 'Inhabilitado',
    name: 'Nombre',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    label_message: 'Mensaje: ',
    label_description: 'Descripcion: ',
    label_preview: 'Vista Previa: ',
    created_by: 'Creado por:',
    canceled_by: 'Cancelado por:',
    terminated_by: 'Terminado por:',
    assigned_by: 'Asignado por:',
    rate_management: 'Gestión de Tarifas',
    lastConnection: 'Última Conexión',
    message: 'Mensaje',
    duration: 'Duración',
    title: 'Título',
  },
  models: {
    users: 'Usuario | Usuarios',
    drivers: 'Conductor | Conductores',
    drivers_connected: 'Conductores Conectados'
  },
  actions: {
    submit: 'Enviar',
    edit: 'Editar',
    close: 'Cerrar',
    create: 'Crear',
    delete: 'Eliminar',
    restart: 'Reiniciar',
    cancel: 'Cancelar',
    release: 'Liberar',
    assign: 'Asignar',
    terminate: 'Terminar',
    filter: 'Filtrar',
    see: 'Ver',
    back: 'Regresar',
    copy_phone: 'Copiar teléfono',
    clear_filters: 'Limpiar Filtros',
    items_pages: 'Elementos Por Pagina',
    set_percentage: 'Establecer Porcentaje',
    send_message: 'Enviar Mensaje',
    add: 'Agregar',
    claim_chat: 'Reclamar Chat',
    toggle_full: 'Modo Saturado',
  },
  messages: {
    updated: 'Recurso actualizado correctamente',
    created: 'Recurso creado correctamente',
    deleted: 'Recurso eliminado correctamente',
    error: 'Algo salió mal!',
    waiting: 'Por favor espere...',
    waitingSub: 'Esto solo tomará un momento',
    forbidden: 'Permiso denegado!',
    error_chatBot: 'El chatBot y las notificaciones de WhatsApp no pueden estar habilitadas al mismo tiempo!',
    error_assistant: 'El chatBot y el asistente no pueden estar habilitados al mismo tiempo!',
    copied: 'Copiado al portapapeles!',
    new_message: 'Nuevo mensaje',
    chat_claimed_success: 'Chat reclamado exitosamente',
    chat_claim_failed: 'Error al reclamar el chat. Por favor intenta de nuevo.',
    no_session_found: 'No se Encontró Sesión',
    no_session_found_text: 'No se encontró una sesión activa para reclamar en este chat',
  },
  placeholders: {
    optional: 'Opcional',
    name: 'Ingrese el nombre',
    email: 'Ingrese el email',
    phone: 'Ingrese el teléfono',
    phone2: 'Ingrese el teléfono 2 (Opcional)',
    password: 'Contraseña',
    confirm_password: 'Confirmar contraseña',
    restore_password: '¿Restablecer Contraseña?',
    address: 'Ingrese la dirección',
    comment: 'Ingrese un comentario (opcional)',
    search: 'Buscar',
    map: 'Mapa',
    all: 'Todos',
    dark: 'Tema Oscuro',
    light: 'Tema Claro',
    device: 'No tiene dispositivo registrado',
    cancel_percent: 'Índice de cancelación',
    weekly: 'Semanal',
    daily: 'Diario',
    daily_top_5: 'Top 5 diario',
    weekly_top_5: 'Top 5 semanal',
    monthly_top_5: 'Top 5 mensual',
    monthly_frequency: 'Mensual',
    top5_title: 'Top 5',
    top5_period_day: 'Día',
    top5_period_week: 'Sem.',
    top5_period_month: 'Mes',
    top5_empty: 'Sin datos',
    year_service_progress: 'Progreso de servicios anual',
    first_place: 'Primer lugar',
    kpi_group_service: 'Servicio',
    kpi_group_revenue: 'Ingresos',
    kpi_services_month: 'Servicios · mes',
    kpi_completion_rate: 'Tasa de finalización',
    kpi_cancellation_rate: 'Tasa de cancelación',
    kpi_leading_driver: 'Conductor líder',
    kpi_leading_driver_empty: 'Sin servicios este mes',
    kpi_services_unit: 'servicios',
    kpi_commission_income: 'Ingresos por comisión',
    kpi_monthly_fee_income: 'Ingresos por cuota mensual',
    kpi_paying_drivers: 'conductores mensuales',
    kpi_cash_collected: 'Efectivo recaudado',
    kpi_recharges_count: 'recargas',
    income_by_charge_type: 'Ingresos por tipo de cobro',
    income_breakdown: 'Desglose de ingresos mensual',
    income_series_commission: 'Comisión por servicio',
    income_series_monthly_fee: 'Mensualidad fija',
    income_total: 'Total',
    service_info: 'Información del servicio',
    route_info: 'Información de la ruta y conductor',
    monthly: 'Mensualidad',
    percentage: 'Porcentaje',
    current_percentage: 'Porcentaje actual',
    duration: 'Duración (en minutos)',
    description: {
      plate: 'Placa del vehículo',
      vehicle_color: 'Color de vehículo',
      username: 'Nombre',
      company_number: 'Numero de Empresa',
      place_name: 'Lugar',
      company_name: 'Nombre de la empresa',
    },
    label: {
      plate: 'Placa',
      color: 'Color',
      name: 'Nombre',
      number_pqr: 'PQR',
      place_name: 'Lugar',
      company_name: 'Empresa',
    },
    timeline: 'Línea de tiempo',
    canceled_by_section: 'Cancelación',
    no_destination: 'Sin destino',
  },
  forms: {
    select_img: 'Choose image from files'
  },
  breadcrumb: {
    root: 'Páginas'
  },
  filters: {
    title: 'Filtros',
    from: 'Desde',
    until: 'Hasta',
    driver_plate: 'Placa conductor',
    number_client: 'Número del cliente',
    origin: 'Origen'
  },
  chatBot: {
    connected: 'Conectado',
    disconnected: 'Desconectado',
    disconnect: 'Desconectar',
    connect: 'Conectar',
    reset: 'Reiniciar'
  },
  colors: {
    black: 'Negro',
    blue: 'Azul',
    gray: 'Gris',
    green: 'Verde',
    purple: 'Purpura',
    red: 'Rojo',
    white: 'Blanco',
    pink: 'Rosado',
    orange: 'Naranja',
    gold: 'Dorado',
    yellow: 'Amarillo',
    magenta: 'Magenta',
    cyan: 'Cyan',
    brown: 'Café',
    maroon: 'Marrón',
    beige: 'Beige',
    silver: 'Plateado'
  },
  settings: {
    wpNotifications: 'Confirmaciones de WhatsApp',
    alert_notifications: 'No se enviarán mensajes hasta que las confirmaciones estén habilitadas',
    chatBot: 'WhatsApp ChatBot',
    assistant: 'Asistente Bot',
    alert_chatBot: 'Habilita el chatBot para que gestione completamente los servicios',
    alert_assistant: 'Habilita el asistente para crear servicios cuando el cliente envía la ubicación',
    agentInTrip: 'Agente en Viaje',
    alert_agentInTrip: 'Requiere el chatBot habilitado. Mantiene al agente respondiendo después de asignar un conductor',
    Ride_Fees: 'Tarifas',
    Messages: 'Mensajes',
    fees_base_title: 'Tarifas Base',
    add_time_slot: 'Agregar Franja',
    price_kilometer: 'Precio por kilómetro',
    price_minute: 'Precio por Minuto',
    fees_base: 'Tarifa Base',
    fees_additional: 'Tarifas Adicionales',
    fees_minimum: 'Tarifa Mínima Actual',
    fees_minimum_day: 'Tarifa Mínima Diurna',
    fees_minimum_nigth: 'Tarifa Mínima Nocturna',
    fees_minimum_festive: 'Tarifa Mínima Festiva Diurna',
    fees_minimum_festive_nigth: 'Tarifa Mínima Festiva Nocturna',
    dynamic_min_fee: 'Tarifa Mínima Dinámica',
    dynamic_multiplier_fee: 'Multiplicador Dinámico de Tarifa',
    self_service_cancel_window_title: 'Cancelación de Autoservicio',
    self_service_cancel_window: 'Ventana de cancelación (segundos)',
    self_service_cancel_window_hint: 'Tiempo máximo, en segundos, que tiene el conductor para cancelar un viaje de autoservicio antes de que la ventana expire.',
    hour_range: 'Horarios',
    fees_night: 'Nocturno',
    fees_DxF: 'Domingos y Festivos',
    fees_night_DxF: 'Domingos y Festivos Nocturnos',
    general_settings: 'Ajustes Generales',
    cities: 'Ciudades',
    currency_code: 'Código de Moneda',
    calling_code: 'Código de Llamada',
    branches: 'Sucursales'
  },
  titles: {
    title_modal: 'Editar Mensajes de WhatsApp',
    title_card: 'Tabla de Mensajes WhatsApp'
  },
  errors: {
    invalid_duration: 'Duración inválida mínimo 1 minuto',
  },
  paginator: {
    summary: 'Mostrando {from}–{to} de {total}',
    empty: 'Ningún conductor coincide con los filtros actuales',
    go_to_page: 'Ir a la página',
    per_page: 'Elementos por página',
  }
}